import React from "react";
import { colors } from "stylesheets";

export default function({ color }) {
  const fill = colors[color] || colors.primary;
  return (
    <svg
      width="52"
      height="39"
      viewBox="0 0 52 39"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M46.667 0.500244H5.33366C2.48424 0.500244 0.166992 2.63062 0.166992 5.25024V10.0002H51.8337V5.25024C51.8337 2.63062 49.5164 0.500244 46.667 0.500244ZM0.166992 33.7502C0.166992 36.3699 2.48424 38.5002 5.33366 38.5002H46.667C49.5164 38.5002 51.8337 36.3699 51.8337 33.7502V19.5002H0.166992V33.7502ZM7.91699 26.6252H23.417V31.3752H7.91699V26.6252Z"
        fill={fill}
      />
    </svg>
  );
}
